import React, { useState, useEffect } from 'react'
import { Container } from './styled'
import { useTranslation } from 'react-i18next'
import { Grid, MenuItem, TextField, Button, Modal, Typography, Box, IconButton, Drawer } from '@mui/material'
import { ModalContent, BookingModalContent } from './styled'
import { EditorState } from 'draft-js';
import { convertToHTML } from 'draft-convert';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { getBookings, acceptBooking, createBookingPlan, getVenuePrice } from 'api'
import dayjs from 'dayjs';
import GroupBookingForm from '../groupBookingForm/view';
import { DayCalendarSkeleton } from '@mui/x-date-pickers/DayCalendarSkeleton';
import { loadStripe } from '@stripe/stripe-js';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import Badge from '@mui/material/Badge';
import {  REACT_APP_STRIPE_KEY } from 'config/api';
import FilterListIcon from '@mui/icons-material/FilterList'
import CloseIcon from '@mui/icons-material/Close'
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import CancelOutlined from '@mui/icons-material/CancelOutlined';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import BookingListContainer from './bookingListContainer';
import BookingDetail from 'components/pages/booking/bookingDetail/view';

const BookingList = ({ slug, communities }) => {

  const { t } = useTranslation()
  const [bookings, setBookings] = useState([])
  const [showPendingModal, setShowPendingModal] = useState(false);
  const [pendingBookings, setPendingBookings] = useState([]);
  const [message] = useState('')
  const [formData, setFormData] = useState({})
  const [theBooking, setBooking] = useState({})
  const [messageEditorState] = useState(EditorState.createEmpty())
  const [openConfirm, setOpenConfirm] = useState(false)
  const [bookingConfirm, setBookingConfirm] = useState(false)
  const [confirmAction, setConfirmAction] = useState({})
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [sessionId, setSessionId] = useState(null)
  const stripePromise = REACT_APP_STRIPE_KEY ? loadStripe(REACT_APP_STRIPE_KEY) : null;
  const [prices, setPrices] = useState([])
  const [openDetails, setOpenDetails] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [filters, setFilters] = useState({
    status: 'AL',
    venue: '',
    code: '',
    date: '',
    order_by: '',
    order_dir: 'desc',
    page_size: 10,
    page_number: 1
  });

  const [paginationInfo, setPaginationInfo] = useState({
    page_number: 1,
    page_size: 10,
    page_total: 1,
    results_total: 0
  });

  const statusMapping = {
    AL: 'All',
    AC: 'Confirmed',
    PP: 'Pending Payment',
    PC: 'Pending Confirmation',
    PN: 'Pending',
    PB: 'Pre-Booked',
    PR: 'Prepaid',
    CA: 'Cancelled',
    FilterNoneTwoTone: 'Finished',
    RJ: 'Declined'
  };


  const statusOptions = [
    { value: 'AL', label: 'All' },
    { value: 'AC', label: 'Confirmed' },
    { value: 'PC', label: 'Pending Confirmation' },
    { value: 'CA', label: 'Cancelled' },
    { value: 'FN', label: 'Finished' },
    { value: 'RJ', label: 'Declined' }
  ];


  const [highlightedDays, setHighlightedDays] = useState([1, 5, 7, 10, 20, 27])
  const [isLoading, setIsLoading] = useState(false);
  const [bookingLoaded, setBookingLoaded] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false)

  function clearFilters() {
    setFilters({
      status: 'AL',
      venue: '',
      code: '',
      date: '',
      order_by: '',
      order_dir: 'desc',
      page_size: 10,
      page_number: 1
    });
  }

  // Add this function to check pending bookings
  const checkPendingBookings = (bookingsData) => {
    const pending = bookingsData.filter(booking => booking.status === 'PC');
    if (pending.length > 0 && pendingBookings.length === 0) {
      setPendingBookings(pending);
      setShowPendingModal(true);
    }
  };

  function ServerDay(props) {
    const { day, outsideCurrentMonth, ...other } = props;

    // Check if prices is an array
    if (!Array.isArray(prices)) {
      return null; // or handle it in a way that makes sense for your application
    }
    // Check if there is a price for the current day
    const priceInfo = prices?.find((price) => {
      const priceDate = new Date(price.start);
      return priceDate.toISOString().split('T')[0] === props.day.format('YYYY-MM-DD');
    });

    return (
      <Badge
        key={props.day.toString()}
        overlap="circular"
        badgeContent={priceInfo ? `£${priceInfo?.price}` : undefined}
      >
        <PickersDay {...other} outsideCurrentMonth={outsideCurrentMonth} day={day} />
      </Badge>
    );
  }

  function navigateBooking(booking) {
    //navigate(`/bookings/${booking?.slug}`);
    setSelectedBooking(booking)
    setOpenDetails(true)
    //window.location.href = '/login'
  }

  const doBooking = () => {
    const formattedDate = selectedDate.format('DD/MM/YYYY');

    const data = {
      title: formData.title,
      description: formData.description,
      venue: slug,
      group: formData.group,
      date: formattedDate,
      number_spaces: formData.spaces,
      booking_type: 'HD',
      price: formData.price,
      fee: formData.fee,
    }
    createBookingPlan(data).then(r => {
      setSessionId(r.sessionId)
    })
      .catch(console.error)

  };

  function getVenuePricesInfo() {
    getVenuePrice(slug).then(r => {
      setPrices(r.prices)
    })
      .catch(console.error)
  }

  function bookingAction(slug, action) {
    if (action === 'accept' || action === 'reject') {
      setConfirmAction({ slug, action })
      setOpenConfirm(true)
      setPendingBookings(pendingBookings.filter(booking => booking.slug !== slug));
    }
    if (action === 'info') {
      navigateBooking(slug)
    }
  }

  function doConfirm() {
    acceptBooking(confirmAction).then(() => {
      fetchBookings()
      setOpenConfirm(false)
    }).catch(console.error)
  }

  const handleMonthChange = () => {
    setIsLoading(true);
    setHighlightedDays([]);
    setIsLoading(false);
  };


  function fetchBookings() {
    setBookingLoaded(false)
    getBookings(filters).then(r => {
      setBookings(r?.bookings)

      setBookingLoaded(true)
      setPaginationInfo({
        page_number: parseInt(r.page_number),
        page_size: parseInt(r.page_size),
        page_total: parseInt(r.page_total),
        results_total: parseInt(r.results_total)
      });
      checkPendingBookings(r?.bookings);
    })
  }

  const handleSortChange = (column) => {
    const newOrderDir = filters.order_by === column && filters.order_dir === 'asc' ? 'desc' : 'asc';
    setFilters({
      ...filters,
      order_by: column,
      order_dir: newOrderDir,
      page_number: 1 // Reset page number when sorting changes
    });
  };

  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
      page_number: 1
    });
  };

  const handlePageChange = (pageNumber) => {
    setFilters({
      ...filters,
      page_number: pageNumber
    });
  };

  useEffect(() => {
    fetchBookings()
    getVenuePricesInfo(true)
  }, [])

  useEffect(() => {
    if (sessionId != null) {
      const redirectToCheckout = async () => {
        const stripe = await stripePromise;
        const { error } = await stripe.redirectToCheckout({
          sessionId: sessionId,
        });

        if (error) {
          console.error(error.message);
          // Handle the error, e.g., display a message to the user
        }
      }
      redirectToCheckout()
    }

  }, [sessionId])

  useEffect(() => {
    const htmlMessage = convertToHTML(messageEditorState.getCurrentContent())
    setBooking({ ...theBooking, message: htmlMessage })
  }, [message])

  useEffect(() => {
    fetchBookings()

  }, [filters])

  return (
    <Container sx={{ position: 'relative' }}>
      <Box
        onClick={() => setDrawerOpen(true)}
        sx={{
          display: { xs: 'flex', md: 'none' },
          position: 'fixed',
          right: 0,
          top: '33%',
          transform: 'translateY(-50%) translateX(0)',
          backgroundColor: 'primary.main',
          color: 'white',
          padding: '12px 8px',
          borderRadius: '8px 0 0 8px',
          cursor: 'pointer',
          alignItems: 'center',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          transition: 'transform 0.3s ease',
          '&:hover': {
            transform: 'translateY(-50%) translateX(-4px)',
            backgroundColor: 'primary.dark',
          },
          zIndex: 1000,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            transform: 'rotate(-90deg)',
          }}
        >
          <FilterListIcon
            sx={{
              fontSize: '20px',
              transform: 'rotate(90deg)' // Counter-rotate the icon
            }}
          />
        </Box>
      </Box>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        transitionDuration={{ enter: 400, exit: 300 }}
      >
        <Box
          sx={{
            padding: 3,
            width: 300,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'background.default'
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mb: 3,
              pb: 2,
              borderBottom: '1px solid',
              borderColor: 'divider'
            }}
          >
            <Typography variant="h6">{t('Filters')}</Typography>
            <IconButton
              onClick={() => setDrawerOpen(false)}
              sx={{
                color: 'text.secondary',
                '&:hover': {
                  backgroundColor: 'action.hover'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Filter Groups */}
          <Box sx={{ flex: 1, overflowY: 'auto' }}>
            <Box sx={{ mb: 3 }}>
              <Typography
                variant="subtitle2"
                color="text.secondary"
                sx={{ mb: 1 }}
              >
                {t('Booking Status')}
              </Typography>
              <TextField
                select
                fullWidth
                name="status"
                value={filters.status}
                onChange={handleFilterChange}
                variant="outlined"
                size="small"
              >
                {statusOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {t(option.label)}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            <Box sx={{ mb: 3 }}>
              <Typography
                variant="subtitle2"
                color="text.secondary"
                sx={{ mb: 1 }}
              >
                {t('Booking Details')}
              </Typography>
              <TextField
                fullWidth
                label={t('Code')}
                name="code"
                value={filters.code}
                onChange={handleFilterChange}
                variant="outlined"
                size="small"
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                type="date"
                name="date"
                value={filters.date}
                onChange={handleFilterChange}
                variant="outlined"
                size="small"
                sx={{
                  '& .MuiInputLabel-root': {
                    transform: 'translate(14px, 8px) scale(1)',
                  },
                  '& .MuiInputLabel-shrink': {
                    transform: 'translate(14px, -9px) scale(0.75)',
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    position: 'relative',
                    backgroundColor: 'background.default',
                    px: 1,
                  }
                }}
                label={t('Date')}
              />
            </Box>

            <Box sx={{ mb: 4 }}>
              <Typography
                variant="subtitle2"
                color="text.secondary"
                sx={{ mb: 1 }}
              >
                {t('Sort Options')}
              </Typography>
              <TextField
                select
                fullWidth
                name="order_by"
                value={filters.order_by}
                onChange={handleFilterChange}
                variant="outlined"
                size="small"
              >
                <MenuItem value="planned_start_day">{t('Day')}</MenuItem>
                <MenuItem value="venue__name">{t('Venue')}</MenuItem>
                <MenuItem value="status">{t('Status')}</MenuItem>
                <MenuItem value="code">{t('Code')}</MenuItem>
              </TextField>
            </Box>
          </Box>

          {/* Footer Actions */}
          <Box
            sx={{
              pt: 2,
              borderTop: '1px solid',
              borderColor: 'divider',
              display: 'flex',
              gap: 2
            }}
          >
            <Button
              variant="outlined"
              onClick={clearFilters}
              fullWidth
            >
              {t('Clear All')}
            </Button>
            <Button
              variant="contained"
              onClick={() => setDrawerOpen(false)}
              fullWidth
            >
              {t('Apply')}
            </Button>
          </Box>
        </Box>
      </Drawer>
      <Grid container spacing={2} sx={{ display: { xs: 'none', md: 'flex' }, padding: '5px 25px' }}>
        <Grid item xs={3}>
          <TextField
            select
            label={t('Status')}
            name="status"
            value={filters.status}
            onChange={handleFilterChange}
            variant="outlined"
            fullWidth
          >
            {statusOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {t(option.label)}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={2}>
          <TextField
            label={t('Code')}
            name="code"
            value={filters.code}
            onChange={handleFilterChange}
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid item xs={5}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <TextField
              label={t('Date')}
              name="date"
              type="date"
              value={filters.date}
              onChange={handleFilterChange}
              variant="outlined"
              sx={{ width: '180px' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleFilterChange({ target: { name: 'date', value: dayjs().format('YYYY-MM-DD') } })}
              sx={{
                minWidth: 'auto',
                whiteSpace: 'nowrap',
                borderRadius: '20px'
              }}
            >
              {t('Today')}
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleFilterChange({ target: { name: 'date', value: dayjs().add(1, 'day').format('YYYY-MM-DD') } })}
              sx={{
                minWidth: 'auto',
                whiteSpace: 'nowrap',
                borderRadius: '20px'
              }}
            >
              {t('Tomorrow')}
            </Button>
          </Box>
        </Grid>
        <Grid item xs={1}>
          <Button
            variant="outlined"
            size="small"
            color="secondary"
            onClick={clearFilters}
            sx={{
              minWidth: 'auto',
              height: '100%',
              borderRadius: '20px'
            }}
          >
            {t('Clear')}
          </Button>
        </Grid>
      </Grid>

      <BookingListContainer
        bookings={bookings}
        filters={filters}
        setFilters={setFilters}
        handleSortChange={handleSortChange}
        handlePageChange={handlePageChange}
        navigateBooking={navigateBooking}
        statusMapping={statusMapping}
        paginationInfo={paginationInfo}
        bookingAction={bookingAction}
        bookingLoaded={bookingLoaded}
        t={t}
        pendingBookings={pendingBookings}
      />


      <Modal
        open={openDetails}
        onClose={() => setOpenDetails(false)}
        aria-labelledby="confirmation-modal-title"
        aria-describedby="confirmation-modal-description"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          // Add this to ensure modal remains scrollable
          '& .MuiModal-root': {
            overflowY: 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }
        }}
      >
        <ModalContent width="80%">
          <BookingDetail booking={selectedBooking} view="tenant" handleBookingAction={bookingAction} />
        </ModalContent>
      </Modal>

      {/* <Fab
        color="secondary"
        aria-label="add"
        sx={{ position: 'fixed', bottom: 16, right: 16 }}
        onClick={() => setBookingConfirm(true)}
      >
        <AddIcon />
      </Fab> */}
      <Modal
        open={showPendingModal}
        onClose={() => setShowPendingModal(false)}
        aria-labelledby="pending-modal-title"
        aria-describedby="pending-modal-description"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            backgroundColor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            maxWidth: '500px',
            width: '90%',
            position: 'relative',
            maxHeight: '90vh',
            overflow: 'auto',
          }}
        >
          <IconButton
            onClick={() => setShowPendingModal(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'text.secondary'
            }}
          >
            <CloseIcon />
          </IconButton>

          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <NotificationsActiveIcon
              sx={{
                fontSize: 48,
                color: 'warning.main',
                mb: 2
              }}
            />
            <Typography
              variant="h5"
              component="h2"
              sx={{ fontWeight: 500, mb: 2 }}
            >
              {t('Pending Bookings')}
            </Typography>
            <Typography sx={{ color: 'text.secondary', mb: 3 }}>
              {t('You have')} {pendingBookings.length} {t('bookings pending approval')}
            </Typography>
          </Box>



          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
            <Button
              variant="contained"
              onClick={() => {
                setShowPendingModal(false);
              }}
              sx={{ borderRadius: '20px', minWidth: '120px' }}
            >
              {t('Show All Pending')}
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby="confirmation-modal-title"
        aria-describedby="confirmation-modal-description"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: { xs: 2, sm: 4 }
        }}
      >
        <Box
          sx={{
            backgroundColor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: { xs: 3, sm: 4 },
            maxWidth: '400px',
            width: '100%',
            position: 'relative'
          }}
        >
          <IconButton
            onClick={() => setOpenConfirm(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'text.secondary'
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          <Box sx={{ textAlign: 'center', mb: 3 }}>
            {confirmAction.action === 'accept' ? (
              <CheckCircleOutline sx={{ fontSize: 48, color: 'success.main', mb: 2 }} />
            ) : (
              <CancelOutlined sx={{ fontSize: 48, color: 'error.main', mb: 2 }} />
            )}
            <Typography
              id="confirmation-modal-title"
              variant="h5"
              component="h2"
              sx={{ fontWeight: 500 }}
            >
              {confirmAction.action === 'accept' ? 'Confirm Booking' : 'Reject Booking'}
            </Typography>
            <Typography
              id="confirmation-modal-description"
              sx={{ mt: 2, color: 'text.secondary' }}
            >
              Are you sure you want to {confirmAction.action === 'accept' ? 'confirm' : 'decline'} this booking?
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              gap: 2,
              justifyContent: 'center',
              mt: 4
            }}
          >

            <Button
              variant="contained"
              onClick={() => doConfirm()}
              color={confirmAction.action === 'accept' ? 'success' : 'error'}
              sx={{
                minWidth: '120px',
                borderRadius: '20px'
              }}
            >
              {confirmAction.action === 'accept' ? 'Confirm' : 'Decline'}
            </Button>
            <Button
              variant="outlined"
              onClick={() => setOpenConfirm(false)}
              sx={{
                minWidth: '120px',
                borderRadius: '20px'
              }}
            >
              No, go back
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={bookingConfirm}
        onClose={() => setBookingConfirm(false)}
        aria-labelledby="booking-modal-title"
        aria-describedby="booking-modal-description"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <BookingModalContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={8}>
              <GroupBookingForm formData={formData} setFormData={setFormData} communities={communities} />
            </Grid>

            <Grid item xs={12} md={4}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateCalendar
                  value={selectedDate}
                  loading={isLoading}
                  onMonthChange={handleMonthChange}
                  renderLoading={() => <DayCalendarSkeleton />}
                  slots={{
                    day: ServerDay,
                  }}
                  slotProps={{
                    day: {
                      highlightedDays,
                    },
                  }}
                  onChange={(newValue) => setSelectedDate(newValue)}
                />
              </LocalizationProvider>

              <Button variant='contained' color='button_color' onClick={() => doBooking()}>Book</Button>
            </Grid>
          </Grid>
        </BookingModalContent>
      </Modal>
    </Container >
  )
}

BookingList.propTypes = {

}

export default BookingList
